<template>
  <div class="mx-auto text-center">
    <v-carousel hide-delimiters :height="carouselHeight" v-model="selected">
      <template v-if="!mobile">
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="700" class="mx-auto">
              <v-img max-width="700" :src="require(`@/assets/landing/map/map_google_${this.$vuetify.lang.current}.jpg`)"
                     eager></v-img>
            </v-card>
          </v-row>
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-sheet
            color="blue"
            height="100%"
            tile>
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="display-3">Google support</div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </template>

      <template v-if="!mobile">
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="700" class="mx-auto">
              <v-img max-width="700" :src="require(`@/assets/landing/map/map_yandex_${this.$vuetify.lang.current}.jpg`)"
                     eager></v-img>
            </v-card>
          </v-row>
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-sheet
            color="orange"
            height="100%"
            tile>
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="display-3">Yandex support</div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </template>

      <template v-if="!mobile">
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="700" class="mx-auto">
              <v-img max-width="700"
                     :src="require(`@/assets/landing/map/map_citygid_${this.$vuetify.lang.current}.jpg`)"
                     eager></v-img>
            </v-card>
          </v-row>
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-sheet
            color="green"
            height="100%"
            tile>
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="display-3">CityGid support</div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </template>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'mapCarousel',
  data: () => ({
    selected: 0
  }),
  computed: {
    carouselHeight () {
      if (this.mobile) {
        return 550
      } else {
        return 650
      }
    },
    mobile () {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    }
  }
}
</script>

<style scoped>

</style>
